import 'twin.macro';
import { GenericSport } from '@/graphql/gql/graphql';
import { useMemo } from 'react';
import Header from './header/HeaderContainer';
import Footer from './footer/Footer';
import MobileSubNavigation from './header/MobileSubNavigation/MobileSubNavigation';

export type LayoutProps = {
  children: JSX.Element;
  sport?: Partial<GenericSport> | string
  sportName?: string;
  preview?: boolean;
};

export function HomeLayout({ children, ...pageProps }: LayoutProps) {
  const sport = useMemo(() => {
    if (pageProps.sportName) return pageProps.sportName;
    return (typeof pageProps.sport === 'string' ? pageProps.sport : pageProps.sport?.name);
  }, [pageProps.sport, pageProps.sportName]);
  return (
    <>
      <Header sport={sport} />
      <div tw="m-auto bg-gray-light">{children}</div>
      <div tw="border-t border-gray-mid">
        <Footer />
      </div>
    </>
  );
}

export default function Layout({ children, ...pageProps }: LayoutProps) {
  const isPreview = pageProps.preview;
  const sport = useMemo(() => {
    if (pageProps.sportName) return pageProps.sportName;
    return (typeof pageProps.sport === 'string' ? pageProps.sport : pageProps.sport?.name);
  }, [pageProps.sport, pageProps.sportName]);

  // do not render headers and footer if preview screen
  if (isPreview) {
    return (
      <div tw="flex flex-col items-center justify-center bg-gray-light p-6">
        {children}
      </div>
    );
  }
  return (
    <>
      <Header sport={sport} />
      <MobileSubNavigation sport={sport} />
      <main tw="m-auto mt-14 bg-gray-light xl:container md:mt-0">{children}</main>
      <div tw="m-4 border-t border-gray-mid bg-gray-100 sm:m-auto">
        <Footer />
      </div>
    </>
  );
}
